import { Option } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

export const isPlanInPlans = (planId: string | undefined, plansOptions: Option[]): boolean => {
  if (!planId || !plansOptions?.length) return false;
  return plansOptions.some((plan) => plan.key === planId);
};

export const getEmployeeAge = (birthDate?: string): number => {
  if (!birthDate) return 0;
  return Math.abs(dayjs(birthDate, DEFAULT_DATE_FORMAT).diff(dayjs(), 'years'));
};
